import http from '../../shared/http.js';
import { withFlash } from '../../shared/flash.js';
import { hideLoading, notifyError, notifySuccess, showLoading } from '../../shared/notify.js';

// The decisions on a lead's detail page: qualify, reject, re-run the automation.
//
// One handler on the wrapper rather than one per button, the same shape the
// lists use - the module reads data-action off whatever was clicked.
//
// Merging is deliberately not here. It needs a candidate to merge *into*, which
// means choosing one from the duplicates section, and that section is filled by
// the automation. The API route exists and is tested; the control belongs beside
// the candidates it picks from rather than in this row of buttons.

const AKTIONEN = {
  qualifizieren: {
    pfad: 'qualifizieren',
    // Asked for, because it creates a second record and there is no undo short
    // of deleting the candidate by hand.
    frage: 'Diesen Lead qualifizieren? Es wird ein Kandidat angelegt.',
    erfolg: 'Lead wurde qualifiziert.',
    flash: 'lead-qualifiziert'
  },
  ablehnen: {
    pfad: 'ablehnen',
    frage: 'Diesen Lead ablehnen?',
    erfolg: 'Lead wurde abgelehnt.',
    flash: 'lead-abgelehnt'
  },
  automatik: {
    pfad: 'automatik',
    // Not asked: re-running changes nothing a person did - the automation skips
    // a lead somebody is already on - so the worst outcome is that it finds
    // nothing new.
    frage: null,
    erfolg: 'Automatik wurde erneut ausgeführt.',
    flash: null
  }
};

async function ausfuehren(wrapper, name) {
  const aktion = AKTIONEN[name];
  if (!aktion) return;

  const { leadId } = wrapper.dataset;
  if (!leadId) return;

  if (aktion.frage && !window.confirm(aktion.frage)) return;

  showLoading('Wird ausgeführt …');

  try {
    await http.post(`/leads/${leadId}/${aktion.pfad}`);

    // A reload rather than a patch of the DOM: every one of these changes the
    // status badge, the available buttons and the timeline at once, and the
    // server already renders all three correctly.
    window.location.href = aktion.flash
      ? withFlash(`/leads/${leadId}`, aktion.flash)
      : `/leads/${leadId}`;
  } catch (err) {
    hideLoading();
    notifyError(
      err.response?.data?.message || 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.'
    );
    return;
  }

  notifySuccess(aktion.erfolg);
}

export function initLeadAktionen() {
  const wrapper = document.getElementById('lead-aktionen');
  if (!wrapper) return;

  wrapper.addEventListener('click', (event) => {
    const button = event.target.closest('[data-action]');
    if (!button || !wrapper.contains(button)) return;

    event.preventDefault();
    ausfuehren(wrapper, button.dataset.action);
  });
}
